export default function kFormatter(num) {
  if (num > 999999) {
    return `${(num / 1000000).toFixed(2)}m`;
  } else if ( num > 999) {
    return `${(num / 1000).toFixed(1)}k`;
  }
  return num;
}